
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ErrorBag, Field } from "vee-validate";
import { RegisterUserDto } from "@/views/base/base.types";
import BaseMixin from "@/views/base/base.mixin";
import VueSelect from 'vue-select';

type VueSelectInstance = InstanceType<typeof VueSelect>;

@Component
export default class ChangePasswordComponent extends Mixins(BaseMixin) {
  @Prop() registerUserShow!: boolean;

  registerUserDto: RegisterUserDto = new RegisterUserDto();
  loading = false;
  success = false;
  passwordShow = false;

  veeFields!: Field;
  veeErrors!: ErrorBag;

  async mounted()  {
    this.loading = true;
    this.$store.commit("Base/updateField", {
      path: "errorMessage",
      value: null
    });
    await this.fetchData();
    this.loading = false;
  }

  async fetchData() {
    const fetch = [
      this.$store.dispatch("Base/fetchAspNetRoles"),
    ];
    await Promise.all(fetch);
  }

  validateState(ref: keyof Field) {
    if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || 
        this.veeFields[ref].validated)
    ) {
        return !this.veeErrors.has(ref);
    }
    return null;
  }

  viewPassword() {
    this.passwordShow = !this.passwordShow;
  }

  registerUser() {
    this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        await this.$store.dispatch("Base/registerUser", this.registerUserDto);
        this.loading = false;
        this.success = !this.errorMessage;
      }
    });
  }

  handleBlur(refName: string): void {
    const selectComponent = this.$refs[refName] as VueSelectInstance
    const input = selectComponent?.$el?.querySelector('input')
    input?.blur()
  }

  closeModal() {
    this.$emit('update:registerUserShow', false);
  }
}
